import { useState } from "react";

const useFetch = url => {
	const [processing, setProcessing] = useState(false);
	const fetchData = _url => {
		setProcessing(true);
		return fetch(url || _url)
			.then(response => response.json())
			.then(resultData => {
				setProcessing(false);
				return resultData;
			})
			.catch(() => {
				setProcessing(false);
				return null;
			});
	};
	return [processing, fetchData];
};

export default useFetch;
export { useFetch };
